module.exports = __webpack_public_path__ + "media/images/game_icon/vi/VG0003-bfc41a6f4640d85c0d83f2ec81536e53.png";